import {RootState} from 'store';

export const selectDomain = (state: RootState) => state.global;
